import { Ability } from 'ember-can';

export default class SignOutAbility extends Ability {
  // Getter and setter
  get canRead() {
    return true;
  }
}
